import { useMutation } from "@tanstack/react-query";
import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../../utils/GeneralUtils";
import TenantAPI from "../../../api/TenantAPI";
import useCloudPermissions from "../../../../hooks/useCloudPermissions";

const useBackupCloud = () => {
  const { cPermissions } = useCloudPermissions();

  const backupCloud = useMutation({
    mutationFn: () => {
      if (!cPermissions.cloud_trigger_backup) {
        return Promise.reject(
          "You don't have permission to backup this cloud."
        );
      }

      return TenantAPI.backupCloudNow();
    },

    onSuccess: (_, { onSuccess }: { onSuccess: () => void }) => {
      callFunctionIfExists(onSuccess);
    },
  });

  return {
    backupCloud: backupCloud.mutate,
    loadingBackup: backupCloud.isPending,
    backupError: backupCloud.error ? getErrorMessage(backupCloud.error) : null,
  };
};

export default useBackupCloud;
